import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyNzFormFieldModule } from '@ngx-formly/ng-zorro-antd/form-field';
import { NzSelectModule } from 'ng-zorro-antd/select';

/**
 * @fileoverview added by tsickle
 * Generated from: select.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ng-zorro-antd/select';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@ngx-formly/core';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@ngx-formly/core/select';

function FormlyFieldSelect_ng_container_1_nz_option_group_1_nz_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nz-option", 6);
} if (rf & 2) {
    const child_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("nzValue", child_r5.value)("nzDisabled", child_r5.disabled)("nzLabel", child_r5.label);
} }
function FormlyFieldSelect_ng_container_1_nz_option_group_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nz-option-group", 4);
    ɵngcc0.ɵɵtemplate(1, FormlyFieldSelect_ng_container_1_nz_option_group_1_nz_option_1_Template, 1, 3, "nz-option", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("nzLabel", item_r1.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r1.group);
} }
function FormlyFieldSelect_ng_container_1_nz_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nz-option", 6);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("nzValue", item_r1.value)("nzDisabled", item_r1.disabled)("nzLabel", item_r1.label);
} }
function FormlyFieldSelect_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FormlyFieldSelect_ng_container_1_nz_option_group_1_Template, 2, 2, "nz-option-group", 2);
    ɵngcc0.ɵɵtemplate(2, FormlyFieldSelect_ng_container_1_nz_option_2_Template, 1, 3, "nz-option", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.group);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r1.group);
} }
class FormlyFieldSelect extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            templateOptions: { options: [] },
        };
    }
}
FormlyFieldSelect.ɵfac = function FormlyFieldSelect_Factory(t) { return ɵFormlyFieldSelect_BaseFactory(t || FormlyFieldSelect); };
FormlyFieldSelect.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldSelect, selectors: [["formly-field-nz-select"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 12, consts: [[3, "nzPlaceHolder", "formControl", "formlyAttributes", "nzMode"], [4, "ngFor", "ngForOf"], [3, "nzLabel", 4, "ngIf"], [3, "nzValue", "nzDisabled", "nzLabel", 4, "ngIf"], [3, "nzLabel"], [3, "nzValue", "nzDisabled", "nzLabel", 4, "ngFor", "ngForOf"], [3, "nzValue", "nzDisabled", "nzLabel"]], template: function FormlyFieldSelect_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nz-select", 0);
        ɵngcc0.ɵɵtemplate(1, FormlyFieldSelect_ng_container_1_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵpipe(3, "formlySelectOptions");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ng-dirty", ctx.showError);
        ɵngcc0.ɵɵproperty("nzPlaceHolder", ctx.to.placeholder)("formControl", ctx.formControl)("formlyAttributes", ctx.field)("nzMode", ctx.to.multiple ? "multiple" : "default");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 7, ɵngcc0.ɵɵpipeBind2(3, 9, ctx.to.options, ctx.field)));
    } }, directives: [ɵngcc1.NzSelectComponent, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc3.FormlyAttributes, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc1.NzOptionGroupComponent, ɵngcc1.NzOptionComponent], pipes: [ɵngcc4.AsyncPipe, ɵngcc5.ɵa], encapsulation: 2 });
const ɵFormlyFieldSelect_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(FormlyFieldSelect);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormlyFieldSelect, [{
        type: Component,
        args: [{
                selector: 'formly-field-nz-select',
                template: `
    <nz-select
      [class.ng-dirty]="showError"
      [nzPlaceHolder]="to.placeholder"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [nzMode]="to.multiple ? 'multiple' : 'default'"
    >
      <ng-container *ngFor="let item of to.options | formlySelectOptions: field | async">
        <nz-option-group *ngIf="item.group" [nzLabel]="item.label">
          <nz-option
            *ngFor="let child of item.group"
            [nzValue]="child.value"
            [nzDisabled]="child.disabled"
            [nzLabel]="child.label"
          >
          </nz-option>
        </nz-option-group>
        <nz-option
          *ngIf="!item.group"
          [nzValue]="item.value"
          [nzDisabled]="item.disabled"
          [nzLabel]="item.label"
        ></nz-option>
      </ng-container>
    </nz-select>
  `
            }]
    }], null, null); })();
if (false) {
    /** @type {?} */
    FormlyFieldSelect.prototype.defaultOptions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: select.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyNzSelectModule {
}
FormlyNzSelectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FormlyNzSelectModule });
FormlyNzSelectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FormlyNzSelectModule_Factory(t) { return new (t || FormlyNzSelectModule)(); }, imports: [[
            CommonModule,
            ReactiveFormsModule,
            NzSelectModule,
            FormlyNzFormFieldModule,
            FormlySelectModule,
            FormlyModule.forChild({
                types: [
                    {
                        name: 'select',
                        component: FormlyFieldSelect,
                        wrappers: ['form-field']
                    },
                ]
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormlyNzSelectModule, { declarations: function () { return [FormlyFieldSelect]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        NzSelectModule,
        FormlyNzFormFieldModule,
        FormlySelectModule, ɵngcc3.FormlyModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormlyNzSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [FormlyFieldSelect],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    NzSelectModule,
                    FormlyNzFormFieldModule,
                    FormlySelectModule,
                    FormlyModule.forChild({
                        types: [
                            {
                                name: 'select',
                                component: FormlyFieldSelect,
                                wrappers: ['form-field']
                            },
                        ]
                    }),
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-formly-ng-zorro-antd-select.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { FormlyFieldSelect, FormlyNzSelectModule };

//# sourceMappingURL=ngx-formly-ng-zorro-antd-select.js.map